import { ContentService, DcrKeyPipe, TranslationState } from '@blk/cwp-ng-framework';

import { Formatter } from './formatter.interface';

export class LabelFormatter implements Formatter {
	constructor(public readonly dcrFiller?: string, public enableDcrKeyFormatting?: boolean) { }
	public format(value: any, contentSvc?: ContentService): string | TranslationState {
		let key = value;
		// if the value has spaces or hyphens, replace them with underscore '_' and convert the value to upper case
		// e.g. 'dcr key should have - underscore' will become 'DCR_KEY_SHOULD_HAVE_UNDERSCORE'
		if (this.enableDcrKeyFormatting) {
			key = new DcrKeyPipe().transform(value);
		}
		if (this.dcrFiller) {
			key = this.dcrFiller + '_' + value;
		}
		return contentSvc.resolve(key, value);
	}
}
